module.exports = __webpack_public_path__ + "static/free-employee-scheduling-time-clock-app-25718ac01863e16a998209ce2635a1a2.png";